/* eslint-disable jsx-a11y/anchor-is-valid */
import ApexCharts, { ApexOptions } from 'apexcharts'
import React, { useEffect, useRef } from 'react'
import { getCSSVariableValue } from '../../../_metronic/assets/ts/_utils'

type Props = {
  className: string
  chartColor: string
  chartHeight: string
  relatorio: any
  AllRelatory: any
  lastMessageAndStatus: any
}

const MixedWidget7: React.FC<Props> = ({
  className,
  chartColor,
  chartHeight,
  relatorio,
  AllRelatory,
  lastMessageAndStatus,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!chartRef.current) return

    const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight, relatorio))
    chart.render()

    return () => {
      chart.destroy()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef])

  const RenderTotals = () => {
    if (!lastMessageAndStatus) return null

    const totals = {
      "Contatos Importados": 0,
      "Válidos": 0,
      "Inválidos": 0,
      "Duplicados": 0,
      "Pendentes": 0,
      "Enviadas": 0,
      "EnviadasRespondidas": 0,
      "Respondidas": 0,
      "Com Erros": 0,
      "Bloqueadas": 0,
      "Não Enviadas": 0
    }

    for (const m of lastMessageAndStatus) {
      totals["Contatos Importados"] += 1
          
      if (String(m.validationStatus)?.toLowerCase() === "validated") totals["Válidos"] += 1
      else if (String(m.validationStatus)?.toLowerCase() === "duplicated") totals["Duplicados"] += 1
      else totals["Inválidos"] += 1

      const currentStatus = String(m.status).toLowerCase()
      switch (currentStatus) {
        case "error":
          totals["Com Erros"] += 1
          break
        case "blacklist":
          totals["Bloqueadas"] += 1
          break
        case "answered":
          totals["Respondidas"] += 1
          totals["EnviadasRespondidas"] += 1
          break
        case "sent":
          totals["EnviadasRespondidas"] += 1
          break
        default:
          if (String(m.validationStatus).toLowerCase() === "validated") totals["Pendentes"] += 1
          else totals["Não Enviadas"] += 1
          break
      }
    }

    return (
      <div className="table-responsive mt-5">
        <style>
          {`
            .fine-bordered-table {
              border-collapse: collapse;
              width: 100%;
            }
            .fine-bordered-table td, .fine-bordered-table th {
              border: 1px solid #dee2e6;
              padding: 8px;
              vertical-align: middle;
              text-align: center;
              font-weight: 600;
            }
          `}
        </style>
        <table className="fine-bordered-table">
          <tbody>
            <tr>
              <td><i className="bi bi-people-fill fs-4 text-dark"></i></td>
              <td>Contatos Importados<br />{totals["Contatos Importados"]}</td>
              <td>Válidos<br />{totals["Válidos"]}</td>
              <td>Inválidos<br />{totals["Inválidos"]}</td>
              <td>Duplicados<br />{totals["Duplicados"]}</td>
            </tr>
            <tr>
              <td><i className="bi bi-send-fill fs-4 text-primary"></i></td>
              <td>Pendentes<br />{totals["Pendentes"]}</td>
              <td>Enviados<br />{totals["EnviadasRespondidas"]}</td>
              <td>Respondidos<br />{totals["Respondidas"]}</td>
            </tr>
            <tr>
              <td><i className="bi bi-exclamation-triangle-fill fs-4 text-danger"></i></td>
              <td>Bloqueados<br />{totals["Bloqueadas"]}</td>
              <td>Não Enviados<br />{totals["Não Enviadas"]}</td>
              <td>Com Erros<br />{totals["Com Erros"]}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 py-5 pb-0 pt-9 d-block'>
        <h3 className='card-title align-items-start d-block'>
          <span className='card-label fw-bolder fs-3 mb-1 d-block'>Progresso da campanha</span>
          <span className='text-muted fw-bold fs-7 d-block'>Relatório em tempo real</span>
        </h3>
        {RenderTotals()}
      </div>

      {/* begin::Body */}
      <div className='card-body d-flex flex-column pt-0'>
        <div className='flex-grow-1'>
          <div ref={chartRef} className='mixed-widget-4-chart'></div>
        </div>
      </div>
      {/* end::Body */}
    </div>
  )
}

const chartOptions = (chartColor: string, chartHeight: string, relatorio: any): ApexOptions => {
  const baseColor = getCSSVariableValue('--bs-' + chartColor)
  const lightColor = getCSSVariableValue('--bs-light-' + chartColor)
  const labelColor = getCSSVariableValue('--bs-gray-700')

  return {
    series: [relatorio],
    chart: {
      fontFamily: 'inherit',
      height: chartHeight,
      type: 'radialBar',
    },
    plotOptions: {
      radialBar: {
        hollow: {
          margin: 0,
          size: '65%',
        },
        dataLabels: {
          name: {
            show: false,
            fontWeight: '700',
          },
          value: {
            color: labelColor,
            fontSize: '30px',
            fontWeight: '700',
            offsetY: 12,
            show: true,
            formatter: function (val) {
              return val + '%'
            },
          },
        },
        track: {
          background: lightColor,
          strokeWidth: '100%',
        },
      },
    },
    colors: [baseColor],
    stroke: {
      lineCap: 'round',
    },
    labels: ['Progress'],
  }
}

export default MixedWidget7
